import type maplibregl from "maplibre-gl";

/** Map view the left Nearby list was loaded for (sort distances stay tied to this). */
export type NearbyListAnchor = { lng: number; lat: number; zoom: number };

export type NearbyStaleScreen = {
  zoom: number;
  anchorPx: { x: number; y: number };
  centerPx: { x: number; y: number };
  viewportMin: number;
};

const DEFAULT_CENTER_FRACTION = 0.3;
const DEFAULT_ZOOM_DELTA = 1.5;

/** True when the map has moved enough that we should offer reloading the Nearby list. */
export function nearbySearchAreaStale(
  anchor: NearbyListAnchor,
  screen: NearbyStaleScreen,
  opts?: { centerFraction?: number; zoomDelta?: number },
): boolean {
  const zoomDelta = opts?.zoomDelta ?? DEFAULT_ZOOM_DELTA;
  if (Math.abs(screen.zoom - anchor.zoom) >= zoomDelta) return true;
  const threshold = screen.viewportMin * (opts?.centerFraction ?? DEFAULT_CENTER_FRACTION);
  const dist = Math.hypot(screen.anchorPx.x - screen.centerPx.x, screen.anchorPx.y - screen.centerPx.y);
  return dist > threshold;
}

export function nearbyStaleScreenFromMap(map: maplibregl.Map, anchor: NearbyListAnchor): NearbyStaleScreen {
  const box = map.getContainer();
  const anchorPx = map.project([anchor.lng, anchor.lat]);
  return {
    zoom: map.getZoom(),
    anchorPx: { x: anchorPx.x, y: anchorPx.y },
    centerPx: { x: box.clientWidth / 2, y: box.clientHeight / 2 },
    viewportMin: Math.min(box.clientWidth, box.clientHeight),
  };
}

export function nearbySearchAreaStaleForMap(
  map: maplibregl.Map,
  anchor: NearbyListAnchor | null,
  opts?: { centerFraction?: number; zoomDelta?: number },
): boolean {
  if (!anchor) return false;
  return nearbySearchAreaStale(anchor, nearbyStaleScreenFromMap(map, anchor), opts);
}
